import { StaticProvider } from '@angular/core';

import { ProvideOutletOptions, provideOutlet, OutletService, OutletPosition } from '@spartacus/storefront';
import { BrandsEnum } from '@seb/web-design-system/core';

/**
 * Generate an outlet provider
 * @param appBrand The main application brand
 * @param options The outlet options
 * @returns And array of one or more providers
 */
export function generateOutletProviders(appBrand: BrandsEnum, options: ProvideOutletOptions): StaticProvider[] {
  return (appBrand === BrandsEnum.rowenta) ? ['Calor', 'Krups', 'Seb', 'Rowenta'].map(
    (brand) => provideOutlet({
      ...options,
      id: (brand === 'Rowenta') ? `${options.id}` : `${brand}-${options.id}`
    })
  ) : [
    provideOutlet(options)
  ];
}

export function addOutletTemplateWithBrands(outletService: OutletService, template: string, comparatorFactory: any, position: OutletPosition.REPLACE) {
  outletService.add(template, comparatorFactory, position);
  ['Calor', 'Krups', 'Seb', 'Rowenta'].forEach(
    (brand) => outletService.add(`${brand}-${template}`, comparatorFactory, position)
  );
}
